import { render, staticRenderFns } from "./MenuJF.vue?vue&type=template&id=3e08ca2a&scoped=true&"
import script from "./MenuJF.vue?vue&type=script&lang=js&"
export * from "./MenuJF.vue?vue&type=script&lang=js&"
import style0 from "./MenuJF.vue?vue&type=style&index=0&id=3e08ca2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e08ca2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContent,VImg,VProgressCircular,VRow})
